import { Component, ElementRef, EventEmitter, Output, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { qmsService } from '../../qms.service';
import { PaginationService } from 'src/app/PaginationService';
import { AuService } from '../au.service';
import { AuQuestionsComponent } from '../au-questions/au-questions.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-pick-questions',
  templateUrl: './pick-questions.component.html',
  styleUrls: ['./pick-questions.component.scss']
})

export class PickQuestionsComponent implements OnInit {

  isProcessing: boolean;
  @Output() response = new EventEmitter<{ responses: any }>();

  constructor(public dialog: MatDialog, private readonly appService: AppService, public paginationService: PaginationService, public router: Router, private readonly snackBar: MatSnackBar, public message: messageService, private readonly elem: ElementRef,
    public qmsservice: qmsService, public auService: AuService, private readonly auQuestions: AuQuestionsComponent) {
  }

  ngOnInit() {
    this.getcallMethod();
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  ccpDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  questions: any = [];

  getcallMethod() {
    this.questions = [];
    const data = {

      gridName: "QUESTIONNAIRE_TEMPLATE_QUESTIONS"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_QUESTIONNAIRE_TEMPLATE_QUESTIONS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: "QUESTION_SEQ",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          templateIdFromQmsQuestionnaireTemplate: this.auService.questionTemplateId,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.questions = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }
                for (const question of this.questions) {
                  for (const element of this.dataTypeList) {
                    if (element.fieldType == 'CHECKBOX') {
                      question[element.columnName] = question[element.columnName] == "Y";
                    }
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              },
              error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });
            this.message.gridList = this.questions;
            this.collectionSize = this.questions.length;
            this.totalPages = Math.ceil(this.questions.length / this.itemsPerPage);
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.questions.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.questions.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  questionArray: any = [];
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.parentCheckBox = true;
      this.questionArray = [];
      this.questions.forEach((question: any) => {
        question.childCheckBoxs = true;
        this.questionArray.push({
          questionId: question.QUESTION_ID,
          questionSeq: question.QUESTION_SEQ,
          question: question.QUESTION,
          fieldTypeCode: question.FIELD_TYPE_CODE,
          fieldValues: question.FIELD_VALUES ?? null,
        });
      });
      console.log(this.questionArray);
    } else {
      this.parentCheckBox = false;
      for (const element of this.questions) {
        element.childCheckBoxs = false;
        this.questionArray = [];
      }
      console.log(this.questionArray);
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
      this.questionArray.push({
        questionId: list.QUESTION_ID,
        questionSeq: list.QUESTION_SEQ,
        question: list.QUESTION,
        fieldTypeCode: list.FIELD_TYPE_CODE,
        fieldValues: list.FIELD_VALUES,
      })
      console.log(this.questionArray);
      if (this.questions.length == this.questionArray.length && (!this.parentCheckBox)) this.parentCheckBox = true;
    } else {
      list.childCheckBoxs = false;
      const indexToRemove = this.questionArray.findIndex((item: any) => item.questionId === list.QUESTION_ID);
      if (indexToRemove !== -1) {
        this.questionArray.splice(indexToRemove, 1); // Remove the item from the array
        console.log(this.questionArray);
      }
      if (this.parentCheckBox) this.parentCheckBox = false;
    }
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.questions.length, page, this.perPage, targetpage);
    this.pagedItems = this.questions
      .slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  pickQuestions() {

    if (this.questionArray.length < 1) {
      alert("Please pick the questions !")
    } else {
      this.isProcessing = true;

      const promises: Promise<any>[] = [];
      const responses: any = [];

      for (const element of this.questionArray) {
        const data = {
          auNo: this.qmsservice.activityId,
          questionSeq: element.questionSeq,
          question: element.question,
          fieldTypeCode: element.fieldTypeCode,
          fieldValues: element.fieldValues
        };

        const observable = this.appService.createQmsAuQuestion(data);
        const promise = firstValueFrom(observable).then((response: any) => {
          responses.push({ result: response, question: data })
        }).catch((error) => {
          responses.push({ result: error, question: data });
        });

        promises.push(promise);
      }

      Promise.all(promises).then(() => {
        const failedResponses = responses.filter((response: any) => response.resultType == 'E');
        this.response.emit(responses);
        if (!failedResponses.length) {
          this.auQuestions.visibleSelectQuestionPopup.close();
          this.auQuestions.visibleAddPopup.close();
          this.auQuestions.displayQuestionsFunction();
        }
      }).catch((error) => {
        this.isProcessing = false;
        throw error;
      })
    }
  }

  cancelQuestions() {
    this.auQuestions.visibleSelectQuestionPopup.close();
  }


  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }


}
